<template>
  <div class="buscar">
    <!-- Se Slug Organizador -->
    <!-- <div class="advanced-search-organizer background-natal">
    </div> -->
        <v-layout justify-center class="pt-4">
          <h1 style="color: #770700">Selecione o evento</h1>
        </v-layout>
        <v-container fluid grid-list-xl class="page-content">
          <v-layout row wrap>
          <v-flex class="xs12">
          <div class="results" v-for="(date,i) in orderedList" :key="i">
            <v-layout class="px-3 pb-2">
            <h1 style="color: black">{{ formatDate(date.date)}}</h1>
            </v-layout>
            <v-layout wrap>
                <v-flex class="pb-5" xs12 sm12 md4 lg4 v-for="item in date.events" :key="item.order">
                  <event-item
                  style="width: 390px !important"
                  :event-data="item"
                  :link="eventUrl(item)"
                  :img="showImage(item.url)"
                  :title="item.nome"
                  :description_1="item.data_horario_exibicao"
                  :description_2="getHorarioEvento(item)"
                  :description_3="item.local"
                  :description_4="`${item.nome_cidade}, ${item.uf_cidade}`"
                  >
                  </event-item>
                </v-flex>
              </v-layout>
              </div>
              <div v-if="list ? list.length === 0 : false">Nenhum evento encontrado</div>
            </v-flex>
          </v-layout>
          <v-layout v-if="list" class="py-3" row wrap justify-center>
            <v-btn :loading="loading" round depressed color="#770700" style="text-transform: none; height: 46px; width: 150px" dark @click="refreshEvents">Mais 7 dias</v-btn>
          </v-layout>
        </v-container>
  </div>
</template>

<script>
import $http from '@/http.js';
import getUniqueValues from '@/utils/get-unique-values.js'
import EventItem from './EventItem'
import moment from 'moment'
// import validationMixin from '@/mixins/validationMixin.js'

export default {
  name: 'OrganizerSlug',
  components: {
    EventItem,
  },
  data () {
    return {
      titulo: null,
      listParams: null,
      organizerDetails: null,
      list: null,
      listPast: null,
      active: null,
      loading: false,
      sendMessageDialog: false,
      sendMessageValid: false,
      message: [],
      addDays: 7
    }
  },
  computed: {
    listLength () {
      return this.orderedList() ? this.orderedList().length : 0
    },
    orderedList () {
      if (this.list) {
        let dates = []
        this.list.forEach(l => {
          if (dates.find(d => {
            return d.date === l.data.split(' ')[0]
          })) return
          else {
            dates.push({
              date: l.data.split(' ')[0],
              events: []
            })
          }
        })
        dates.forEach(d => {
          this.list.forEach(l => {
            if (l.data.split(' ')[0] === d.date)
            d.events.push(l)
          })
        })
        return dates
      } else return []
    },
  },

  async mounted () {
    let currentDate = moment().get('date')
    let currentMonth = moment().get('month') + 1
    let initDate = null
    if (currentMonth === 10 && currentDate <= 28) {
      initDate = moment().format('YYYY-MM-28')
    } else initDate = moment().format('YYYY-MM-DD')
    let endDate = moment(initDate).add(7, 'days').format('YYYY-MM-DD')
    this.asyncData(initDate, endDate)
    await this.$store.dispatch('deleteCheckoutState');
    localStorage.removeItem('checkoutState')
  },

  methods: {
    showImage (img) {
      if (!!img && img.length > 0) {
        return img
      }

      return 'https://s3.amazonaws.com/blueticket-cdn/images/imagens/compact/21420.jpg'
    },
    formatDate (date) {
      if (moment(date).format('DD/MM/YYYY') === moment().format('DD/MM/YYYY')) return 'Hoje'
      if (moment(date).format('DD/MM/YYYY') === moment().add(1, 'days').format('DD/MM/YYYY')) return 'Amanhã'
      return moment(date).format('DD/MM/YYYY')
    },
    async refreshEvents () {
      this.loading = true
      this.addDays += 7
      let currentDate = moment().get('date')
      let currentMonth = moment().get('month') + 1
      let initDate = null
      if (currentMonth === 10 && currentDate <= 28) {
        initDate = moment().format('YYYY-MM-28')
      } else initDate = moment().format('YYYY-MM-DD')
      let endDate = moment(initDate).add(this.addDays, 'days').format('YYYY-MM-DD')
      await this.asyncData(initDate, endDate)
      this.loading = false
    },
    async asyncData (initDate, endDate) {
    try {
      let organizer = await $http.get(`/v2/organizers/page/details/3914?min_data=${initDate}&max_data=${endDate}`, {headers: {PDV: 31821}})
      this.list = organizer.data.eventos_futuros
      this.organizerDetails = organizer.data
    } catch (e) {
      if (e.response) {
        console.log(e.response.data)
        console.log(e.response.status)
        console.log(e.response.headers)
      } else if (e.request) {
        console.log(e.request)
      } else {
        console.log('Error', e.message)
      }
      console.log(e.config)
      error({ statusCode: 404, message: 'Slug não encontrado' })
    }
  },
    openSendMessageModal () {
      this.sendMessageDialog = true
    },
    closeSendMessageModal () {
      this.sendMessageDialog = false
      this.message = []
    },
    async sendMessage () {
      try {
        let params = {
          codigo_organizador: this.organizerDetails.codigo,
          nome: this.message.name,
          email: this.message.email,
          mensagem: this.message.message
        }
        let { data } = await this.$axios.post(`/v2/organizers/customer/message/send`, params)

        if (data.success) {
          this.toastSuccess('Mensagem enviada ao organizador!')
          this.closeSendMessageModal()
        } else {
          this.toastError(data.message)
        }
      } catch (e) {

      }
    },
    orderedListPast () {
      const self = this
      return getUniqueValues(this.listPast, 'codigo').sort((a, b) => self.$moment(a.data) - self.$moment(b.data))
    },
    getHorarioEvento (item) {
      return item.horario_evento ? item.horario_evento : ''
    },
    eventUrl (item) {
      // return `/${this.slugifyTitle(item.nome)}`
      return `/evento/${item.codigo}` // @TODO !!temporário!! A 'api' não faz ainda a busca por slug
    }
  },
}
</script>

<style scoped>
.background-natal {
  background-image: url('../../assets/logo-natal-luz.png');
  background-repeat: no-repeat;
  background-size:contain;
  background-position:center;
  background-color: #770700;
  width: 100% !important;
  height: 250px !important;
  max-height: 100% !important;
}
</style>
